import type { UseQueryResult } from 'react-query';

import type { Document } from 'state/__generated__/tadaahAPI';

import { useApiDiplomasList } from 'state/__generated__/tadaahAPI';

import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';

type UseGetFreelancerDiplomaDocuments = {
  document: Document | undefined;
  fileName: string | undefined;
  errorDocuement: string | undefined;
  isLoadingDocument: boolean;
  refetchDocument: (options: {
    throwOnError: boolean;
    cancelRefetch: boolean;
  }) => Promise<UseQueryResult>;
};

const useGetFreelancerPersonRegisterDocument =
  (): UseGetFreelancerDiplomaDocuments => {
    const isLoggedIn = useIsFreelancerLoggedIn();

    const { data, error, isLoading, refetch } = useApiDiplomasList({
      query: {
        enabled: isLoggedIn,
        queryKey: ['freelancer-person-register-document'],
      },
    });

    const personRegisterDocument: Document | undefined =
      data?.data.find(
        (document) => document.name === 'Inschrijving Personenregister',
      ) || undefined;

    return {
      document: personRegisterDocument,
      errorDocuement: error?.message,
      fileName:
        personRegisterDocument?.picture?.split('/')?.slice(-1)?.[0] ||
        personRegisterDocument?.pdf?.split('/')?.slice(-1)?.[0],
      isLoadingDocument: isLoading,
      refetchDocument: refetch,
    };
  };

export default useGetFreelancerPersonRegisterDocument;
